module.exports = __webpack_public_path__ + "media/images/badge-overnight-08ae9dc06915d4af7c3b3a8c74245884.svg";